import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-860412b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-reports bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-row pt-6 pb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Rapportini")
], -1))
const _hoisted_6 = { class: "titles grid grid-cols-5 text-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Data creazione rapportino", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Ore di lavoro", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Dipendenti", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, null, -1))
const _hoisted_11 = { class: "entry-list" }
const _hoisted_12 = { class: "see-more pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_WorkReportCard = _resolveComponent("WorkReportCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header w-full fixed relative inline-flex cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_LeftArrow, { class: "back-arrow" }),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.scope == _ctx.ClockingInScope.workingSite ? 'Nome dipendente' : 'Nome cantiere'), 1),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workReports, (workReport) => {
            return (_openBlock(), _createBlock(_component_WorkReportCard, {
              key: workReport.id,
              "model-value": workReport,
              scope: _ctx.scope
            }, null, 8, ["model-value", "scope"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h2", {
            class: "font-bold text-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paginate()))
          }, "Carica altri rapportini")
        ])
      ])
    ])
  ]))
}